import { createFileRoute } from '@tanstack/react-router';

import { SyncScopus } from '@/module/Sync/SyncScopus';

export const Route = createFileRoute('/_auth/sync-scopus')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'sync.scopus.title' },
  },
});

function RouteComponent() {
  return <SyncScopus />;
}
